import { Component } from '@angular/core';
import { HeaderComponent } from '@components/dashboard/header/header.component';
import { NavComponent } from '@components/dashboard/navigation/nav.component';
import { CommonModule } from '@angular/common';
import { DashboardService } from '@services/dashboard.service';
import { Booking, RiderEarning, Transactions, partnerEarningSummaryValues } from '@interfaces/models.interface';
import { ServerResponse } from '@interfaces/general.interface';
import { LocalService } from '@services/local.service';
import { FormsModule } from '@angular/forms'; // Import FormsModule here
import {RouterModule} from '@angular/router';
import { Apollo } from 'apollo-angular';
import { ExcelService } from '@services/excel.service';
import { AuthStore } from '@store/auth.store';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MomentModule } from 'ngx-moment';
//FOR THE MAP
import { GoogleMapsModule } from '@angular/google-maps';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';
import {
  BOOKING_EXPRESS_TRANSACTIONS,
  BOOKING_RIDE_MOTOTAXI_TRANSACTIONS,
  FLEET_BOOKING_TRANSACTIONS,
} from '@gql_queries/transactions/queries';
import { ADMIN_FLEET_LIST } from '@gql_queries/taxi_fleet/queries';

import {
  REPORT_TRANSACTION_EXPRESS,
  REPORT_TRANSACTION_OKRIDE,
  REPORT_TRANSACTION_MOTOTAXI,
} from '@gql_queries/report_download/queries';


@Component({
  selector: 'app-dashboard-transactions',
  standalone: true,
  imports: [HeaderComponent, NavComponent, CommonModule, FormsModule, RouterModule, MomentModule, GoogleMapsModule, NgxSpinnerModule],
  templateUrl: './dashboard-transactions.component.html',
  styleUrl: './dashboard-transactions.component.css'
})
export class DashboardTransactionsComponent {
  constructor(private toastr: ToastrService, private apollo: Apollo, private excel: ExcelService, private authStore: AuthStore, private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService) {
    if (this.route.snapshot.queryParams['serviceType'] != undefined) {
      this.autoLoadServiceType = this.route.snapshot.queryParams['serviceType'];
      //this.getInfo();
    }

    if (this.route.snapshot.queryParams['transId'] != undefined) {
      this.autoLoadtransId = this.route.snapshot.queryParams['transId'];
      //this.getInfo();
    }

    console.log(this.autoLoadServiceType);
    console.log(this.autoLoadtransId);
  }

  public partnerEarningTabs: Record<string, any> = {
      orders: true,
      incentive: false,
      bonus: false,
      tip: false,
      withdraw: false
  };

  public transactionList: Transactions[] = [];
  public filteredTransactionList: Transactions[] = [];
  public searchKeyword: string = '';
  public currentSelectedPageList: Transactions[] = [];
  public maxPages: number = 0;
  public disableActionBtns: any = {
      next: false,
      prev: false,
  };
  public riderPages: number[] = [];
  public currentPage: number = 1;
  public pageSize: number = 15;

  public detailViewed: Record<string, any> = {};
  public showDetails: boolean = false;

  //FOR THE MAP (BOOKING DETAILS)
  polyLinePath: google.maps.LatLng[] = [];
  display: any;
  center: google.maps.LatLngLiteral = {
      lat: 22.2736308,
      lng: 70.7512555
  };
  zoom = 15;
  polyLineOptions: google.maps.PolylineOptions = {
      strokeColor: '#D81960',
      strokeOpacity: 1.0,
      strokeWeight: 5,
      clickable: false,
      editable: false,
      visible: true,
      geodesic: true, // Smoothen the edges
  };

  partnerSumamry: partnerEarningSummaryValues = {
      totalPartnerCommisions: 0,
      totalEarnings: 0,
      totalPayout: 0,
  }

  transTabs: Record<string, any> = {
    'express': true,
    'okride': false,
    'mototaxi': false,
    'oktaxi': false
  };

  reportData: any[] = [];
  completeCount = 0;
  ongoingCount = 0;
  cancelledCount = 0;
  pendingCount = 0;

  transSortBy: string = 'dateCreated';
  transSortDirection: string = 'desc';

  activeStatusFilter: string = 'all';

  isDownloading = false;
  private spinnerShownAt = 0;
  private readonly minSpinnerDurationMs = 2000;

  autoLoadServiceType: string = '';
  autoLoadtransId: string = '';


  getUrlParams() {
    // Get query parameters
    /* this.route.queryParams.subscribe(params => {
      // Access individual parameters
      const serviceType = params['serviceType'];
      const transId = params['transId'];

      // If serviceType is present, set the active tab
        if (serviceType) {
          this.autoLoadServiceType = serviceType;
        }

        if (transId) {
          this.autoLoadtransId = transId;
        }
      // Log all parameters
      console.log('URL Parameters:', params);
    }); */

    /* // Get route parameters (if you have them in your route configuration)
    this.route.params.subscribe(params => {
      // Access individual parameters
      const id = params['id'];
      // Add more parameters as needed

      // You can use these parameters here
      console.log('Route Parameters:', params);
    }); */
  }

  ngOnInit(): void {
    // Get URL parameters when component initializes
    this.getUrlParams();

    if (this.autoLoadServiceType) {
      this.tabCallFunction(this.autoLoadServiceType);

      // Wait for transactions to load before trying to find the specific transaction
      setTimeout(() => {
        if (this.autoLoadtransId) {
          let autoloadDetails: Transactions | undefined;

          if (this.autoLoadServiceType === 'express') {
            autoloadDetails = this.transactionList.find(x => x.bookingExpressId === this.autoLoadtransId);
          } else {
            autoloadDetails = this.transactionList.find(x => x.bookingRideId === this.autoLoadtransId);
          }
        }
      }, 1000); // Give time for transactions to load
    } else {
      // Initial fetch
      this.fetchTransactions('express');
    }
  }

  fetchTransactions(servicetype:string = 'all', action: string = ''){
    var fromPage = 1;

    if(action != ''){
        fromPage = this.currentPage;
        switch(action){
            case 'next':
                this.currentPage++
            break;

            case 'prev':
                if(this.currentPage != 1){
                    this.currentPage--
                }//end if
            break;
        }//end swithc
    }//end if

    let requestQry = null;
    if(servicetype == 'express'){
      requestQry = this.apollo
        .watchQuery({
          fetchPolicy: 'network-only',
          query: BOOKING_EXPRESS_TRANSACTIONS,
          variables: {
            sortBy: {
              "sort": this.transSortBy,
              "direction": this.transSortDirection
            }
          }
        });
    } else if (servicetype == 'oktaxi') {
      const fleetFetchId = ++this.fleetBookingsFetchId;
      const fleetInput: Record<string, unknown> = {
        rideType: 'taxi',
        page: 1,
        limit: 100,
        sort: {
          sort: this.transSortBy,
          direction: this.transSortDirection
        }
      };
      if (this.selectedFleetId) {
        fleetInput['fleetId'] = this.selectedFleetId;
      }
      requestQry = this.apollo
        .watchQuery({
          fetchPolicy: 'network-only',
          query: FLEET_BOOKING_TRANSACTIONS,
          variables: {
            input: fleetInput
          }
        });
      this.subscribeFleetBookings(requestQry, fleetFetchId, fromPage);
      return;
    } else {
      requestQry = this.apollo
        .watchQuery({
          fetchPolicy: 'network-only',
          query: BOOKING_RIDE_MOTOTAXI_TRANSACTIONS,
          variables: {
            service: servicetype,
            sortBy: {
              "sort": this.transSortBy,
              "direction": this.transSortDirection
            }
          }
        });
    }

    requestQry.valueChanges
    .subscribe({
      next: (res: any) => {
        if(servicetype == 'express'){
            if (res && res.data && res.data.bookingExpressTxns && res.data.bookingExpressTxns.length !== 0) {
                this.transactionList = res.data.bookingExpressTxns;
                this.currentSelectedPageList = this.transactionList;

                this.completeCount = this.transactionList.filter((x) => (x.status === 'completed')).length;
                this.pendingCount = this.transactionList.filter((x) => (x.status === 'pending')).length;
                const ongoingPattern = /^ongoing_/; // Pattern to match any status starting with 'ongoing_'
                this.ongoingCount = this.transactionList.filter((x) => ongoingPattern.test(x.status)).length;
                this.ongoingCount = this.ongoingCount + this.transactionList.filter((x) => (x.status === 'accepted')).length;
                this.cancelledCount = this.transactionList.filter((x) => (x.status === 'canceled')).length;

                this.transactionList.map((x) => {
                    // Create a new object for each entry
                    const fieldListings = {
                        bookingID: x.bookingExpressId,
                        dateCreated: x.dateCreated,
                        notes: x.notes,
                        consumer: x.user != null ? x.user.name : '---',
                        partner: x.partner != null ? `${x.partner.firstName} ${x.partner.lastName}` : '---',
                        status: x.status,
                        totalPrice: x.totalPrice
                    };

                    // Push the new object to the reportData array
                    this.reportData.push(fieldListings);
                });

                //fieldListings['bookingID'] = this.transactionList.
            }else{
                this.currentPage = fromPage;
            } // end if
        }else{
            if (res && res.data && res.data.bookingRideTxns && res.data.bookingRideTxns.length !== 0) {
                this.transactionList = res.data.bookingRideTxns;
                this.currentSelectedPageList = this.transactionList;

                this.completeCount = this.transactionList.filter((x) => (x.status === 'completed')).length;
                this.pendingCount = this.transactionList.filter((x) => (x.status === 'pending')).length;
                const ongoingPattern = /^ongoing_/; // Pattern to match any status starting with 'ongoing_'
                this.ongoingCount = this.transactionList.filter((x) => ongoingPattern.test(x.status)).length;
                this.ongoingCount = this.ongoingCount + this.transactionList.filter((x) => (x.status === 'accepted')).length;
                this.cancelledCount = this.transactionList.filter((x) => (x.status === 'canceled')).length;

                this.transactionList.map((x) => {
                    // Create a new object for each entry
                    const fieldListings = {
                        bookingID: x.bookingExpressId,
                        dateCreated: x.dateCreated,
                        notes: x.notes,
                        consumer: x.user != null ? x.user.name : '---',
                        partner: x.partner != null ? `${x.partner.firstName} ${x.partner.lastName}` : '---',
                        status: x.status,
                        totalPrice: x.totalPrice
                    };

                    // Push the new object to the reportData array
                    this.reportData.push(fieldListings);
                });

                if(this.autoLoadtransId){
                  let autoloadDetails = this.transactionList.find(x => x.bookingRideId == this.autoLoadtransId);
                  if (autoloadDetails) {
                    this.router.navigate(['/admin/transactions', this.autoLoadServiceType, this.autoLoadtransId]);
                  }
                }
                //fieldListings['bookingID'] = this.transactionList.
            }else{
                this.currentPage = fromPage;
            } // end if
        }
      },
      error: (error) => {
        if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
            this.authStore.logout().subscribe(() => {
                // Optional: Redirect to login page or show message
                this.router.navigate(['/admin/login']);
            });
        }
      }
    });
  }//end fn

  private subscribeFleetBookings(requestQry: any, fleetFetchId: number, fromPage: number): void {
    requestQry.valueChanges.subscribe({
      next: (res: any) => {
        if (fleetFetchId !== this.fleetBookingsFetchId) {
          return;
        }

        const page = res?.data?.fleetBookingTransactions;
        const items = Array.isArray(page?.items) ? page.items : [];
        if (items.length !== 0) {
          this.transactionList = items.map((item: any) => this.normalizeFleetBooking(item));
          this.updateStatusCounts(this.transactionList);
          this.applyFilters();
          this.reportData = [];
          this.transactionList.forEach((x) => {
            this.reportData.push({
              bookingID: x.fleetBookingId || x.bookingRideId,
              dateCreated: x.dateCreated,
              notes: x.notes,
              consumer: x.user != null ? x.user.name : '---',
              partner: x.partner != null ? `${x.partner.firstName} ${x.partner.lastName}` : '---',
              status: x.status,
              totalPrice: x.totalPrice
            });
          });

          if (this.autoLoadtransId) {
            const autoloadDetails = this.transactionList.find(
              (x) => x.fleetBookingId == this.autoLoadtransId || x.bookingRideId == this.autoLoadtransId
            );
            if (autoloadDetails) {
              this.router.navigate(['/admin/transactions', this.autoLoadServiceType, this.autoLoadtransId]);
            }
          }
        } else {
          this.transactionList = [];
          this.currentSelectedPageList = [];
          this.updateStatusCounts([]);
          this.currentPage = fromPage;
        }
      },
      error: (error: any) => {
        if (fleetFetchId !== this.fleetBookingsFetchId) {
          return;
        }
        if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
          this.authStore.logout().subscribe(() => {
            this.router.navigate(['/admin/login']);
          });
        }
      }
    });
  }//end fn

  nextPrev(action: string){
    let activeTab = '';
    Object.keys(this.transTabs).forEach((tab) => {
        if (this.transTabs[tab]) {
            activeTab = tab;
        }
    });

      switch(action){
          case 'next':
              this.fetchTransactions(activeTab , 'next');
          break;

          case 'prev':
              this.fetchTransactions(activeTab , 'prev');
          break;
      }//end swithc
  }//end fn


  fleetOperatorFilter: string = '';
  fleetOperatorSearch: string = '';
  fleetOperatorDropdownOpen: boolean = false;
  selectedFleetId: string = '';
  fleetOperatorOptions: { fleetId: string; operatorName: string }[] = [];
  private fleetBookingsFetchId = 0;

  filterByStatus(filterKey: string) {
    this.activeStatusFilter = filterKey;
    this.applyFilters();
  }//end fn

  getFleetOperators(): { fleetId: string; operatorName: string }[] {
    const term = this.fleetOperatorSearch.trim().toLowerCase();
    if (!term) {
      return this.fleetOperatorOptions;
    }
    return this.fleetOperatorOptions.filter((op) =>
      op.operatorName.toLowerCase().includes(term)
    );
  }//end fn

  private loadFleetOperatorOptions(): void {
    const collected: { fleetId: string; operatorName: string }[] = [];
    const loadPage = (page: number) => {
      this.apollo.query({
        fetchPolicy: 'network-only',
        query: ADMIN_FLEET_LIST,
        variables: { page },
      }).subscribe({
        next: ({ data }: any) => {
          const fleets = Array.isArray(data?.adminFleetList) ? data.adminFleetList : [];
          fleets.forEach((fleet: any) => {
            if (fleet?.fleetId && fleet?.operatorName) {
              collected.push({
                fleetId: fleet.fleetId,
                operatorName: fleet.operatorName,
              });
            }
          });

          if (fleets.length > 0 && page < 20) {
            loadPage(page + 1);
            return;
          }

          const byId = new Map<string, { fleetId: string; operatorName: string }>();
          collected.forEach((op) => byId.set(op.fleetId, op));
          this.fleetOperatorOptions = Array.from(byId.values()).sort((a, b) =>
            a.operatorName.localeCompare(b.operatorName)
          );
        },
        error: () => {
          if (page === 1) {
            this.fleetOperatorOptions = [];
          } else {
            const byId = new Map<string, { fleetId: string; operatorName: string }>();
            collected.forEach((op) => byId.set(op.fleetId, op));
            this.fleetOperatorOptions = Array.from(byId.values()).sort((a, b) =>
              a.operatorName.localeCompare(b.operatorName)
            );
          }
        },
      });
    };

    loadPage(1);
  }//end fn

  toggleFleetOperatorDropdown() {
    this.fleetOperatorDropdownOpen = !this.fleetOperatorDropdownOpen;
    if (this.fleetOperatorDropdownOpen) {
      this.fleetOperatorSearch = '';
      if (this.fleetOperatorOptions.length === 0) {
        this.loadFleetOperatorOptions();
      }
    }
  }//end fn

  selectFleetOperator(fleetId: string, name: string) {
    this.selectedFleetId = fleetId;
    this.fleetOperatorFilter = name;
    this.fleetOperatorDropdownOpen = false;
    this.fetchTransactions('oktaxi');
  }//end fn

  private applyFilters() {
    const ongoingPattern = /^ongoing_/;

    this.currentSelectedPageList = this.transactionList.filter((x) => {
      if (this.activeStatusFilter !== 'all') {
        const statusMatches = this.activeStatusFilter === 'ongoing'
          ? (ongoingPattern.test(x.status) || x.status === 'accepted')
          : x.status === this.activeStatusFilter;
        if (!statusMatches) return false;
      }

      return true;
    });
  }//end fn

  getFleetOperatorName(trans: any): string {
    return trans?.fleet?.operatorName
      || trans?.partner?.fleetRegistry?.fleet?.operatorName
      || '---';
  }//end fn

  searchData(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.searchKeyword = inputElement.value;

    if (this.searchKeyword.trim() === '') {
        console.log('Input is empty');
        this.currentSelectedPageList = this.transactionList;
    } else {
        this.currentSelectedPageList = this.transactionList.filter(object => {
            // Helper function to recursively search through nested objects
            const searchInObject = (obj: any): boolean => {
                for (const key in obj) {
                    const value = obj[key];

                    // Skip if null or undefined
                    if (value == null) continue;

                    // If value is an object or array, search recursively
                    if (typeof value === 'object') {
                        if (searchInObject(value)) return true;
                    }
                    // Check if the value includes the search term
                    else if (value.toString().toLowerCase().includes(this.searchKeyword.toLowerCase())) {
                        return true;
                    }
                }
                return false;
            };

            return searchInObject(object);
        });
    }
  }//end nfn

  viewDetails(details: Booking){
    this.showDetails = true;
    if(this.transTabs['express']){
        if(details.orderRoutes != ''){
                this.polyLinePath = google.maps.geometry.encoding.decodePath(details.orderRoutes);
                // Calculate the bounds of the polyline
                const bounds = new google.maps.LatLngBounds();
                this.polyLinePath.forEach((coordinate: google.maps.LatLng) => {
                bounds.extend(coordinate);
            });

            // Center the map to the center of the polyline bounds
            this.center = bounds.getCenter().toJSON();
        }
    }else{
        if(details.routes != ''){
                this.polyLinePath = google.maps.geometry.encoding.decodePath(details.routes);
                // Calculate the bounds of the polyline
                const bounds = new google.maps.LatLngBounds();
                this.polyLinePath.forEach((coordinate: google.maps.LatLng) => {
                bounds.extend(coordinate);
            });

            // Center the map to the center of the polyline bounds
            this.center = bounds.getCenter().toJSON();
        }
    }//end if
    this.detailViewed = details;
    console.log(details);
  }//end fn

  returnToList(){
      //this.setSelectedPageDataBasedOnStatus('all');
      this.showDetails = false;
      this.detailViewed = {};

      this.currentPage = 1;

      this.fetchTransactions();
  }//end fn

  showTabContents(tabindex: string){
      Object.keys(this.partnerEarningTabs).forEach((x) => {
          this.partnerEarningTabs[x] = false;
      });

      this.partnerEarningTabs[tabindex] = true;
  }//end

  private hideSpinnerWithMinimumDelay(){
    const elapsed = Date.now() - this.spinnerShownAt;
    const remainingDelay = Math.max(0, this.minSpinnerDurationMs - elapsed);

    setTimeout(() => {
      this.isDownloading = false;
      this.spinner.hide();
    }, remainingDelay);
  }

  downloadReport() {
    if (this.isDownloading) return;

    const activeStatus = Object.keys(this.transTabs).find((tab) => this.transTabs[tab]);
    if (activeStatus === 'oktaxi') {
      alert('OK! Taxi transaction download is not available yet.');
      return;
    }

    this.isDownloading = true;
    this.spinnerShownAt = Date.now();
    this.spinner.show();

    if (activeStatus) {
      this.downloadReportByStatus(activeStatus);
    } else {
      this.hideSpinnerWithMinimumDelay();
    }
  }//end fn

  downloadReportByStatus(status: string){
    const reportConfig: Record<string, { query: any; dataField: string }> = {
      express: { query: REPORT_TRANSACTION_EXPRESS, dataField: 'expressTransactionReport' },
      okride: { query: REPORT_TRANSACTION_OKRIDE, dataField: 'okRideTransactionReport' },
      mototaxi: { query: REPORT_TRANSACTION_MOTOTAXI, dataField: 'motoTaxiTransactionReport' }
    };

    const selectedConfig = reportConfig[status];
    if (!selectedConfig) {
      this.hideSpinnerWithMinimumDelay();
      return;
    }

    this.apollo.query({
      fetchPolicy: 'network-only',
      query: selectedConfig.query,
      variables: {}
    }).pipe(
      finalize(() => {
        this.hideSpinnerWithMinimumDelay();
      })
    ).subscribe({
      next: (result: any) => {
        const msg: string | undefined = result?.data?.[selectedConfig.dataField]?.message;

        if (msg) {
          this.toastr.success(msg, status.toUpperCase() + ' Report', {
            closeButton: true,
            timeOut: 3000
          });
        } else {
          this.toastr.error('An error occured, please try again', 'UNKNWN_ERR', {
            closeButton: true,
            timeOut: 3000
          });
        }
      },
      error: (error) => {
        if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
          this.authStore.logout().subscribe(() => {
            // Optional: Redirect to login page or show message
            this.router.navigate(['/admin/login']);
          });
        } else {
          this.toastr.error(error.message, error.code, {
            closeButton: true,
            timeOut: 3000
          });
        }
      },
    });
  }

  tabCallFunction(tabIndex: string){
    Object.keys(this.transTabs).forEach((x) => {
        this.transTabs[x] = false;
    });

    this.transTabs[tabIndex] = true;
    this.activeStatusFilter = 'all';
    this.fleetOperatorFilter = '';
    this.selectedFleetId = '';
    if (tabIndex === 'oktaxi') {
      this.loadFleetOperatorOptions();
    }
    this.fetchTransactions(tabIndex);
  }//end fn

  activeServiceTypeKey(): string {
    return Object.keys(this.transTabs).find((tab) => this.transTabs[tab]) || 'express';
  }//end fn

  viewTransactionDetails(trans: Transactions): void {
    this.router.navigate(['/admin/transactions', this.activeServiceTypeKey(), this.getTransactionId(trans)]);
  }//end fn

  /** Align fleet booking payload to ride/express list + details shape. */
  private normalizeFleetBooking(item: any): Transactions {
    return {
      ...item,
      bookingRideId: item.fleetBookingId,
      fleetBookingId: item.fleetBookingId,
      bookingExpressId: item.bookingExpressId || '',
      notes: item.remarks || item.notes || '',
      rating: item.rating || null,
      partnerRating: item.rating || null,
    };
  }

  private updateStatusCounts(list: Transactions[]): void {
    this.completeCount = list.filter((x) => x.status === 'completed').length;
    this.pendingCount = list.filter((x) => x.status === 'pending').length;
    const ongoingPattern = /^ongoing_/;
    this.ongoingCount = list.filter((x) => ongoingPattern.test(x.status)).length;
    this.ongoingCount = this.ongoingCount + list.filter((x) => x.status === 'accepted').length;
    this.cancelledCount = list.filter((x) => x.status === 'canceled').length;
  }

  getTransactionId(trans: Transactions): string {
    if (this.transTabs['express']) {
      return trans.bookingExpressId;
    }
    if (this.transTabs['oktaxi']) {
      return trans.fleetBookingId || trans.bookingRideId;
    }
    return trans.bookingRideId;
  }

  getDetailTransactionId(): string {
    if (this.transTabs['express']) {
      return this.detailViewed['bookingExpressId'];
    }
    if (this.transTabs['oktaxi']) {
      return this.detailViewed['fleetBookingId'] || this.detailViewed['bookingRideId'];
    }
    return this.detailViewed['bookingRideId'];
  }

    onSortChange(){
        let activeTab = '';
        Object.keys(this.transTabs).forEach((tab) => {
            if (this.transTabs[tab]) {
                activeTab = tab;
            }
        });

        this.fetchTransactions(activeTab);
    }

    /*------------------------------------------
    --------------------------------------------
    moveMap()
    --------------------------------------------
    --------------------------------------------*/
    moveMap(event: google.maps.MapMouseEvent) {
        if (event.latLng != null) this.center = (event.latLng.toJSON());
    }

    /*------------------------------------------
    --------------------------------------------
    move()
    --------------------------------------------
    --------------------------------------------*/
    move(event: google.maps.MapMouseEvent) {
        if (event.latLng != null) this.display = event.latLng.toJSON();
    }
}
